import { Star, MessageCircle, ExternalLink } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { MAPS_URL } from "@/lib/constants";

const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJlZVj7Ao5jgcRYMqQzdbV6uQ";

export const Reviews = () => (
  <section id="avaliacoes" data-testid="reviews-section" className="bg-cob-beige/50 py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-cob-dark px-6 py-16 sm:px-12 lg:px-20 text-center">
        <div className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full border border-cob-gold/20" />
        <div className="pointer-events-none absolute -bottom-36 -right-28 h-[380px] w-[380px] rounded-full bg-cob-green/30 blur-3xl" />

        <div className="relative mx-auto max-w-2xl">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-cob-gold">Avaliações</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.9rem] font-semibold tracking-tight leading-[1.12] text-white">
              Sua opinião <span className="italic text-cob-gold">cuida da gente.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-white/70">
              Sua experiência ajuda outras pessoas a encontrarem a Clínica COB. Deixe sua
              avaliação no Google — leva menos de um minuto.
            </p>
          </Reveal>

          <Reveal delay={0.22}>
            <div className="mt-7 flex justify-center gap-1.5" data-testid="reviews-stars">
              {[0, 1, 2, 3, 4].map((i) => (
                <motion.span
                  key={i}
                  initial={{ opacity: 0, scale: 0, rotate: -30 }}
                  whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.25 + i * 0.1, type: "spring", stiffness: 220, damping: 14 }}
                >
                  <Star className="h-8 w-8 fill-cob-gold text-cob-gold drop-shadow-[0_4px_12px_rgba(213,166,66,0.45)]" />
                </motion.span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3.5">
              <a
                href={GOOGLE_REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-write-button"
                className="btn-press inline-flex items-center gap-2.5 rounded-full bg-cob-gold px-8 py-4 text-sm font-bold text-cob-dark transition-all duration-300 hover:bg-white hover:shadow-[0_18px_40px_-14px_rgba(213,166,66,0.6)]"
              >
                <Star className="h-4.5 w-4.5" />
                Avaliar no Google
              </a>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-read-button"
                className="btn-press inline-flex items-center gap-2.5 rounded-full border border-white/25 px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:border-cob-gold hover:text-cob-gold"
              >
                <ExternalLink className="h-4.5 w-4.5" />
                Ver avaliações no Google
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.36}>
            <p className="mt-7 inline-flex items-center gap-2 text-[12px] text-white/50">
              <MessageCircle className="h-3.5 w-3.5" />
              Obrigado por confiar na Clínica COB desde 2004.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
